import { DATETIME_FORMAT_WITH_SECONDS } from "@/constants";
import { toSnakeCase } from "@/lib/utils";
import { formatDateTime } from "@/lib/utils/formatters";
import { ReadAuditLog } from "@/types/auditLog";
import { AuditLogOperationBadge } from "@/modules/auditLogs/components/AuditLogOperationBadge";
import { Calendar, User } from "lucide-react";
import { useTranslation } from "react-i18next";

interface AuditLogDetailsHeaderProps {
  auditLog: ReadAuditLog;
}

export const AuditLogDetailsHeader = ({
  auditLog,
}: AuditLogDetailsHeaderProps) => {
  const { t } = useTranslation();

  const tableName = t(
    `auditLogs.tableName.${toSnakeCase(auditLog.table_name)}`,
  );
  const date = formatDateTime(
    auditLog.changed_at,
    DATETIME_FORMAT_WITH_SECONDS,
  );

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-4">
        <span>{tableName}</span>
        <AuditLogOperationBadge operation={auditLog.operation} />
      </div>
      <div className="flex items-center gap-4 text-sm font-medium text-muted-foreground">
        <span className="flex items-center gap-1.5">
          <Calendar className="h-4 w-4" />
          {date}
        </span>
        <span className="flex items-center gap-1.5">
          <User className="h-4 w-4" />
          {auditLog.changed_by_name}
        </span>
      </div>
    </div>
  );
};
